import styles from '../../styles/plan/blockHeader.scss';
import Tooltip from '../ui/tooltip';
import TOOLTIP_DATA from '../../constants/tooltipData';

interface Props {
  text: string;
  infoKey?: string;
  className?: string;
}

const BlockHeader = (props: Props) => (
  <h5 className={`${props.className || styles.header}`}>
    {props.text}
    {props.infoKey && <Tooltip info={TOOLTIP_DATA[props.infoKey]} />}
  </h5>
);

export default BlockHeader;



// WEBPACK FOOTER //
// ./components/plan/blockHeader.tsx